// latest: zhangmyh 2017-11-9 2:15 PM
// 模板库查询参照？参数type
import Collection from 'common/vo/collection'
import 'collection/templateInfo'
import Model from 'common/vo/model'
import { findIndex } from 'lodash'
import { Get, URLs } from 'common'
import operation from './opt'
import './index.less'
/* global $ u ko __  */

let _config
let classType
let vm
let girdData
let tplModel

// 加载左侧树
let setTree = async function () {
  if (_config.type == 3) {
    classType = _config.type
  } else {
    classType = _config.type + 1
  }
  /** 分类type 和模板type不一致导致（除了3） 需要转化
   CERTIFICATIONINDICATOR("0", "认证指标"), EVALUATIONINDICATOR("1", "评价指标"), QUALIFYCHECKCLASS("2",
   "资质审核模板分类"), FIELDCLASS("3", "现场认证模板分类"), PRODUCTTESTCLASS("4", "产品试验模板分类"), BIDCLASS("5",
   "招标项目评价模板分类"), CTCLASS("6", "合同履约评价模板分类"), EFFECTCLASS("7", "使用效果评价模板分类")
   */
  let data = await Get('/cpu-supplymgr-ay/certificationClass/selectCertificationClassByCondition?type=' + classType + '&isGlobal=' + _config.isGlobal)
  let data2 = []
  data = data.data
  for (let i = 0; i < data.length; i++) {
    let x = {
      id: data[i].id,
      pid: data[i].parentId,
      title: data[i].name,
      code: data[i].code,
      innercode: data[i].innercode,
      open: false
    }
    data2.push(x)
  }
  vm.classTreemodel.removeAllRows()
  vm.classTreemodel.setSimpleData(data2)
}
let url = ''
// 供应分类点击事件
function zTreeOnClick (event, treeId, treeNode) {
  let setOrder = async function () {
    // 创建模板对象，初始化对应的值 tree
    await girdData.load({
      classId: treeNode.id,
      name: vm.searchKey(),
      templetType: _config.type,
      isGlobal: _config.isGlobal,
      enableStatus: 1
    }, { url: url })
  }
  setOrder()
}
const search = () => {
  girdData.load({
    name: vm.searchKey(),
    templetType: _config.type,
    isGlobal: _config.isGlobal,
    enableStatus: 1
  }, { url: url })
}
async function init (refer) {
  if (_config.type > 1) {
    url = URLs.getTplByClassId.url
  } else if (_config.type == 1) {
    url = URLs.getQualifyTplByClassId.url
  }
  // 树形控件加载有误,所以需要每次都重新加载
  girdData = Collection.create('templateInfoList')
  tplModel = Model.create('model.templateRelation')
  // let tree = Collection.create('collection.qualifyclass')
  let selectedData = []
  let selectflag = false
  let changeContent = ''
  let level = ''
  tplModel.datatable.setValue('level', '')
  tplModel.datatable.setValue('changeContent', '')
  // tree.load({ parentId: _config.parentId })
  // 查询当前是否有模板
  setTree()
  vm = {
    searchKey: ko.observable(''),
    search,
    model: tplModel.datatable,
    dokey: function (event, code) {
      if (code.keyCode == 13) {
        vm.search()
      }
    },
    comboData: ko.observableArray([{
      name: '不变',
      value: 1
    },
      {
        name: '提高',
        value: 2
      },
      {
        name: '放宽',
        value: 3
      }]),
    classTreemodel: new window.u.DataTable({
      meta: {
        'id': {
          'value': ''
        },
        'pid': {
          'value': ''
        },
        'title': {
          'value': ''
        },
        'innercode': {
          'value': ''
        }
      }
    }),
    treeOption: {
      view: {
        showLine: false,
        showIcon: false,
        selectedMulti: false,
        dblClickExpand: true,
      },
      data: {
        simpleData: {
          enable: true
        }
      },
      callback: {
        onClick: zTreeOnClick
      }
    },
    gridconfig: {
      id: 'gridtpl',
      data: girdData,
      type: 'grid',
      multiSelect: false,
      editable: false,
      pagination: true,
      fields: [{
        'field': 'code',
        'dataType': 'String',
        'title': '模板编码',
        'width': '20%'
      }, {
        'field': 'name',
        'dataType': 'String',
        'title': '模板名称',
        'width': '20%'
      }, {
        'field': 'description',
        'dataType': 'String',
        'title': '模板描述',
        'width': '30%'
      }, {
        'field': 'className',
        'dataType': 'String',
        'title': '模板所属分类',
        'width': '20%'
      }, {
        'field': 'operation',
        'title': __('operation'),
        dataType: 'action',
        'width': '10%',
        item: operation({
        })
      }]
    }
  }
  let app = u.createApp()
  app.init(vm, $('#tpl_refer')[0])
  refer.registerSubmitFunc(() => {
    console.log('点击确定')
    if (tplModel.datatable.getValue('level') != null && tplModel.datatable.getValue('level') != '') {
      level = tplModel.datatable.getValue('level')
      selectedData.level = level
    }
    console.log('点击确定', selectedData.level)
    if (tplModel.datatable.getValue('changeContent') != null && tplModel.datatable.getValue('changeContent') != '') {
      changeContent = tplModel.datatable.getValue('changeContent')
      selectedData.changeContent = changeContent
    }
    return selectedData
  })

  girdData.on('data', function (result) {
    selectflag = false
    if (_config.multiSelect && !_config.repeatable && refer.options.defaultData) {
      if (selectedData.length <= 0) {
        // 初始化默认值
        let defaultData = refer.options.defaultData()
        if (defaultData instanceof Array) {
          selectedData = defaultData
        }
      }

      let SelectIndex = []
      result.data.result.forEach(function (listItem, i) {
        selectedData.forEach(function (item) {
          if (item.id === listItem.id) {
            SelectIndex.push(i)
          }
        })
      })
      girdData.datatable.setRowsSelect(SelectIndex)
    }
    selectflag = true
  })

  girdData.datatable.on('unSelect', function (obj) {
    let selectData = girdData.datatable.getRowByRowId(obj.rowIds[0])
    // let isBasic = selectData.data.isBasic.value

    let index = findIndex(selectedData, ['id', selectData.data.id.value])
    if (index >= 0) {
      selectedData.splice(index, 1)
    }
  })
  girdData.datatable.on('select', function (obj) {
    if (!_config.multiSelect) {
      if (tplModel.datatable.getValue('level') != null && tplModel.datatable.getValue('level') != '') {
        level = tplModel.datatable.getValue('level')
      }
      if (tplModel.datatable.getValue('changeContent') != null && tplModel.datatable.getValue('changeContent') != '') {
        changeContent = tplModel.datatable.getValue('changeContent')
        selectedData.changeContent = changeContent
      }
      let selectData = girdData.datatable.getCurrentRow().data
      selectedData = {
        id: selectData.id.value,
        name: selectData.name.value,
        code: selectData.code.value,
        classId: selectData.classId.value,
        className: selectData.className.value,
        description: selectData.description.value,
        versionNo: selectData.versionNo.value,
        level: level,
        changeContent: changeContent
      }
      // refer.submit()
      return
    }
    // 默认初始化已选择数据的时候不触发数据改变
    if (selectflag) {
      let selectData = girdData.datatable.getRowByRowId(obj.rowIds[obj.rowIds.length - 1]).data
      let index = findIndex(selectedData, ['id', selectData.id.value])
      if (index >= 0) {
        return
      }
      selectedData.push({
        id: selectData.id.value,
        name: selectData.name.value,
        code: selectData.code.value,
        classId: selectData.classId.value,
        className: selectData.className.value,
        description: selectData.description.value,
        versionNo: selectData.versionNo.value,
        level: level,
        changeContent: changeContent
      })
    }
  })
}

let template = require('./index.html')
export default function (config) {
  _config = Object.assign({
    parentId: 0,
    canRemoveBasic: false,
    multiSelect: true,
    repeatable: false,
    type: 1,
    isGlobal: 0
  }, config)

  return {
    init,
    template
  }
}



// WEBPACK FOOTER //
// ./src/components/modalrefer/tplSelect/index.js